import {
  Directive,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  AfterViewInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {timer} from "rxjs";

@Directive({
  standalone: true,
  selector: '[forceFocus]'
})
export class ForceFocusDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input('forceFocus') enableFocus: boolean = false;
  @Input() delay = 0;

  private intervalId?: number;
  private alive = true;
  private viewInitialized = false;

  constructor(private el: ElementRef, private zone: NgZone) {}

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    if (this.enableFocus) {
      this.focusWithRetry();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.viewInitialized && changes['enableFocus']?.currentValue) {
      this.focusWithRetry();
    }
  }

  private focusWithRetry(maxTries: number = 10) {
    this.zone.runOutsideAngular(() => {
      timer(this.delay)
        .subscribe(() => {
          const element = this.el.nativeElement as HTMLElement;
          this.clear();

          let tries = 0;
          this.intervalId = window.setInterval(() => {
            if (!this.alive) {
              this.clear();
              return;
            }

            if (document.activeElement !== element && this.isVisible(element)) {
              if (tries++ >= maxTries) {
                this.clear();
                return;
              }
              try {
                element.focus({ preventScroll: true });
              } catch (e) {
                // Si le focus échoue, on continue d'essayer
              }
            } else {
              this.clear(); // Succès
            }
          }, 50);
        });
    });
  }

  private isVisible(el: HTMLElement): boolean {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  private clear() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }

  ngOnDestroy(): void {
    this.alive = false;
    this.clear();
  }
}
